import { render, staticRenderFns } from "./footer-contacts.vue?vue&type=template&id=e141388e&scoped=true"
import script from "./footer-contacts.vue?vue&type=script&lang=js"
export * from "./footer-contacts.vue?vue&type=script&lang=js"
import style0 from "./footer-contacts.vue?vue&type=style&index=0&id=e141388e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e141388e",
  null
  
)

export default component.exports